import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--no-ui-slider"
export default class extends Controller {
  connect() {
  }
}
